import React from 'react';
import { Link } from 'react-router-dom';
import CustomHeader from '../components/layout/CustomHeader';
import CustomFooter from '../components/layout/CustomFooter';
import './Services.css';

const Services = () => {
  const handleContactClick = () => {
    window.location.href = '/contact';
  };

  return (
    <>
      <CustomHeader activePage="services" />

      {/* Hero Section */}
      <section className="hero">
        <h1>Software Services</h1>
        <p>Transform your business with our comprehensive software solutions. From web development to enterprise systems, we deliver cutting-edge technology tailored to your needs.</p>
      </section>

      {/* Services Section */}
      <section className="services-section">
        <div className="floating-shapes">
          <div className="shape"></div>
          <div className="shape"></div>
          <div className="shape"></div>
        </div>
        <div className="services-container">
          <div className="services-grid">
            {/* Custom Web Development */}
            <div className="service-card">
              <i className="fas fa-code service-icon"></i>
              <h3>Custom Web Development</h3>
              <p>Tailored web solutions that align with your business goals and user needs.</p>
              <ul className="service-features">
                <li>Responsive Design</li>
                <li>Modern Technologies</li>
                <li>SEO Optimization</li>
                <li>Performance Focus</li>
              </ul>
            </div>

            {/* E-commerce Development */}
            <div className="service-card">
              <i className="fas fa-shopping-cart service-icon"></i>
              <h3>E-commerce Development</h3>
              <p>Powerful online stores that drive sales and enhance customer experience.</p>
              <ul className="service-features">
                <li>Secure Payment Integration</li>
                <li>Inventory Management</li>
                <li>User-friendly Interface</li>
                <li>Analytics & Reporting</li>
              </ul>
            </div>

            {/* Mobile App Development */}
            <div className="service-card">
              <i className="fas fa-mobile-alt service-icon"></i>
              <h3>Mobile App Development</h3>
              <p>Native and cross-platform mobile applications for iOS and Android.</p>
              <ul className="service-features">
                <li>Cross-platform Development</li>
                <li>Native Performance</li>
                <li>Offline Capabilities</li>
                <li>Push Notifications</li>
              </ul>
            </div>

            {/* ERP & LMS Solutions */}
            <div className="service-card">
              <i className="fas fa-cogs service-icon"></i>
              <h3>ERP & LMS Solutions</h3>
              <p>Comprehensive enterprise resource planning and learning management systems.</p>
              <ul className="service-features">
                <li>Process Automation</li>
                <li>Resource Management</li>
                <li>Learning Analytics</li>
                <li>Custom Workflows</li>
              </ul>
            </div>

            {/* Custom App Development */}
            <div className="service-card">
              <i className="fas fa-laptop-code service-icon"></i>
              <h3>Custom App Development</h3>
              <p>Bespoke software solutions designed to address your unique business challenges.</p>
              <ul className="service-features">
                <li>Tailored Solutions</li>
                <li>Scalable Architecture</li>
                <li>Integration Services</li>
                <li>Ongoing Support</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <div className="contact-section">
        <div className="floating-shapes">
          <div className="shape"></div>
          <div className="shape"></div>
          <div className="shape"></div>
        </div>
        <div className="container">
          <h2>Ready to Transform Your Business?</h2>
          <p>Let's discuss how our services can be customized for your specific needs</p>
          <div className="contact-content">
            <div className="contact-info">
              <div className="info-item">
                <i className="fas fa-envelope"></i>
                <span>iuvsupport@inteluniven.in</span>
              </div>
              <div className="info-item">
                <i className="fas fa-phone"></i>
                <span>+91-8484052442</span>
              </div>
              <div className="info-item">
                <i className="fas fa-map-marker-alt"></i>
                <span>Pune, India</span>
              </div>
            </div>
            <button className="contact-btn" onClick={handleContactClick}>
              <span>Start Your Journey</span>
              <i className="fas fa-arrow-right"></i>
            </button>
          </div>
        </div>
      </div>

      <CustomFooter />
    </>
  );
};

export default Services; 